<h1 mat-dialog-title="mat-dialog-title">{{data.title}}</h1>

<div mat-dialog-actions="mat-dialog-actions">
  <button class="btn-painel clear" (click)="closeDialog()" [translate]="'painel-dashboard/cancel'">{{data.no}}</button>
  <button class="btn-painel branded" (click)="confirm()" [translate]="'painel-dashboard/save'">{{data.yes}}</button>
</div>